/**
 * Turns an API error into one readable line (#19): the validator's field messages, the API's
 * `error` string (409 duplicate year, 404), else the interceptor's message. ContractDetail keeps
 * its own copy for now; moving it here is a follow-up after #17 merges.
 */
export function describeApiError(err: unknown): string {
  const fallback = 'Something went wrong';
  if (!err || typeof err !== 'object') return fallback;

  const { response, errorMessage, message } = err as {
    response?: { data?: unknown };
    errorMessage?: unknown;
    message?: unknown;
  };
  const data = response?.data;

  if (data && typeof data === 'object') {
    const { errors, error, title } = data as { errors?: unknown; error?: unknown; title?: unknown };
    if (errors && typeof errors === 'object') {
      const messages = Object.values(errors as Record<string, unknown>)
        .flatMap((value) => (Array.isArray(value) ? value : [value]))
        .filter((value): value is string => typeof value === 'string' && value.length > 0);
      if (messages.length > 0) return messages.join('; ');
    }
    if (typeof error === 'string' && error) return error;
    if (typeof title === 'string' && title) return title;
  }
  if (typeof errorMessage === 'string' && errorMessage) return errorMessage;
  if (typeof message === 'string' && message) return message;
  return fallback;
}
